export function calculateStars(moveCount: number, optimalMoves: number): 0 | 1 | 2 | 3 {
  if (moveCount <= optimalMoves) return 3;
  if (moveCount <= optimalMoves + 2) return 2;
  return 1;
}
